var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCommonQa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44674 13.927C12.2354 13.7416 14.4567 11.4888 14.6395 8.66054C14.6753 8.10708 14.6753 7.53391 14.6395 6.98044C14.4567 4.15221 12.2354 1.89938 9.44674 1.71401C8.49536 1.65077 7.50205 1.6509 6.5526 1.71401C3.76393 1.89938 1.54261 4.15221 1.35983 6.98044C1.32407 7.53391 1.32407 8.10708 1.35983 8.66054C1.4264 9.69062 1.88196 10.6444 2.41828 11.4497C2.72968 12.0135 2.52417 12.7172 2.19982 13.3318C1.96595 13.775 1.84901 13.9966 1.9429 14.1567C2.03679 14.3168 2.24651 14.3219 2.66596 14.3321C3.49545 14.3523 4.0548 14.1171 4.49879 13.7897C4.75061 13.604 4.87652 13.5112 4.9633 13.5005C5.05008 13.4898 5.22085 13.5602 5.56235 13.7008C5.86928 13.8272 6.22565 13.9052 6.5526 13.927C7.50205 13.9901 8.49536 13.9902 9.44674 13.927Z",
    stroke: "#3D3D43",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10L6.22792 6.31623C6.29087 6.12738 6.4676 6 6.66667 6C6.86573 6 7.04246 6.12738 7.10541 6.31623L8.33333 10M10.3333 6V10M5.66667 8.66667H7.66667",
    stroke: "#3D3D43",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCommonQa);
export default __webpack_public_path__ + "static/media/icon-common-qa.98bec19fc567439d8f8f38d255d2b96b.svg";
export { ForwardRef as ReactComponent };